import { render } from "./ApplicationLogo.vue?vue&type=template&id=ad93222a"
const script = {}

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__